import React, { useState, useEffect } from 'react';
import './PartnersLaboratories.css';
import chunk from 'lodash/chunk';

const importAll = (require) => {
  return require.keys().map(require);
};

const PartnersLaboratories = () => {
  const [allImages, setAllImages] = useState([]);
  const [firstImages, setFistImages] = useState([]);
  const [displayedImages, setDisplayedImages] = useState([]);
  const [isOnlyFirstImages, setIsOnlyFirstImages] = useState(true);

  useEffect(() => {
    const allImages = importAll(
      require.context('../../images/partenaires', false, /\.(png|jpe?g|svg)$/)
    );
    const firstImages = chunk(allImages, 15)[0];
    setAllImages(allImages);
    setFistImages(firstImages);
    setDisplayedImages(firstImages);
  }, []);

  return (
    <div className="PartnersLaboratories" id="laboratoires">
      <div className="PartnersLaboratories__title">Laboratoires</div>
      <div className="PartnersLaboratories__images">
        {displayedImages.map((image) => {
          return (
            <div
              className="PartnersLaboratories__image"
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          );
        })}
      </div>
      <button
        onClick={() => {
          if (isOnlyFirstImages) {
            setDisplayedImages(allImages);
            setIsOnlyFirstImages(false);
          } else {
            setDisplayedImages(firstImages);
            setIsOnlyFirstImages(true);
          }
        }}
        type="button"
        className="PartnersLaboratories__button"
      >
        {isOnlyFirstImages ? 'En voir plus' : 'En voir moins'}
      </button>
    </div>
  );
};

export default PartnersLaboratories;
